import { Http } from '@mygpt/app/http';

export interface ImportFAQsParams {
  // 数据集 ID
  datasetId: string;
  file: File;
}

/**
 * 导入问答
 * @param params
 * @returns
 */
export const importFAQsService = (params: ImportFAQsParams) => {
  const { datasetId, file } = params;
  const { post } = Http.use();
  const formData = new FormData();
  formData.append('file', file);
  return post(`/datasets/${datasetId}/faqs/import-faq-template`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
